module.exports = __webpack_public_path__ + "img/secondary_bg2.c10bf6ad.png";